import { currencyFormatter } from "@/utils/currencyFormatter";
import { getLanguageLocal } from "@repo/translation";
import { useSettings } from "@repo/ui";

interface CurrencyProps {
  value?: number;
  currency?: string;
}

export const Currency = ({ value, currency }: CurrencyProps) => {
  const { market, language, general } = useSettings();

  return (
    <>
      {value !== undefined && currency
        ? currencyFormatter({
            value,
            currency,
            locale: getLanguageLocal(language, market),
            showSign: true,
            disableDecimals: Boolean(general?.localization?.disable_decimals),
            fractions: 2,
          })
        : "0"}
    </>
  );
};
